export default "__VITE_ASSET__DEZJ0Apr__"